import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"margin":"6px 8px"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "flex sm4 md3" }
const _hoisted_4 = {
  key: 0,
  class: "flex md4"
}
const _hoisted_5 = { class: "mdo-select" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "account" }, "Conta", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Todas", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "flex sm4 md3" }
const _hoisted_10 = { class: "mdo-select" }
const _hoisted_11 = { for: "sort" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "flex xs6" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Usuário Inativo/a ")
const _hoisted_16 = { style: {"gap":"4px","padding":"2px 0"} }

import {
  Account,
  FilterScopeEnum,
  PermissionEnum,
  RoleEnum,
  SortOrderEnum,
  SortUserInput,
  User,
  UserSearchInput
} from "@/codes/gen/types";
import {UserService} from "@/codes/services/UserService";
import {ReactiveData} from "@/codes/types/MDOTypes";
import {DEFAULT_ITEMS_PER_PAGE, ROUTE_NAMES, VUEX_ACTIONS} from "@/codes/util/constants";
import {calculatePageCount, hasPermission, hasWritePermission} from "@/codes/util/functions";
import {Confirm} from "@/codes/util/swalUtil";
import router from "@/router";
import store from "@/store";
import {onMounted, reactive, ref} from "vue";
import {useI18n} from "vue-i18n";
import Swal from "sweetalert2";
import {AccountService} from "@/codes/services/AccountService";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loadingUsers = ref(false);
let page = 1;
const pageCount = ref(1);
const itemsPerPage = ref(DEFAULT_ITEMS_PER_PAGE);
const users = reactive<ReactiveData<User[]>>({ data: [] as User[] });
const accounts = reactive<ReactiveData<Account[]>>({ data: [] as Account[] });
const filterParamsDefault: UserSearchInput = {
  page: page,
  perPage: itemsPerPage.value,
  scope: FilterScopeEnum.WithTrashed,
  sort: {
    name: SortOrderEnum.Asc
  },
}

const serviceAccount = new AccountService();

let pageLoaded = 0;

const i18n = useI18n();

const headers = reactive({ data: [
  { key: 'name', label: i18n.t('register.name') },
  { key: 'username', label: i18n.t('auth.username') },
  { key: 'email', label: i18n.t('register.email') },
  { key: 'roles', label: i18n.t('register.roles') }
]});

const filter = reactive<ReactiveData<UserSearchInput>>({
  data: {
    page: page,
    perPage: itemsPerPage.value,
    scope: FilterScopeEnum.WithTrashed,
    q: '',
    sort: {name: SortOrderEnum.Asc} as SortUserInput,
    and: {
      account: ''
    }
  } as UserSearchInput
});

const checkHasWritePermission = function() {
  if (hasWritePermission(ROUTE_NAMES.users)) {
    headers.data.push({ key: 'actions', label: i18n.t('form.actions'), width: 75 });
  }
}

const loadUsers = async function(filter: UserSearchInput) {
  users.data = [];
  loadingUsers.value = true;
  const service = new UserService();
  const usersEdge = await service.getAll(filter);
  // const usersEdge = await service.getAll(page, itemsPerPage.value);
  if (usersEdge) {
    pageCount.value = calculatePageCount(itemsPerPage.value, usersEdge.pagination?.total ?? 1);
    users.data = usersEdge.edges;
    pageLoaded = page;
  }
  loadingUsers.value = false;
}

const loadAccounts = async function() {
  accounts.data = [];

  const accountsEdge = await serviceAccount.getAll({
    scope: FilterScopeEnum.WithTrashed,
    sort: {
      name: SortOrderEnum.Asc
    }
  });
  if (accountsEdge) {
    accounts.data = accountsEdge.edges;
  }
}

const getLabelRoles = function (roles?: RoleEnum[]){
  if(!roles){
    return '';
  }

  const labels = roles.map(role => i18n.t(`enums.${role}`))
  return labels.join(', ')
}

const optionsSort = reactive({ data: [
    {
      text: 'Data (recentes)',
      value: { createdAt: SortOrderEnum.Desc }
    },
    {
      text: 'Data (antigos)',
      value: { createdAt: SortOrderEnum.Asc }
    },
    {
      text: 'Nome (ordem alfabética inversa)',
      value: { name: SortOrderEnum.Desc }
    },
    {
      text: 'Nome (ordem alfabética)',
      value: { name: SortOrderEnum.Asc }
    },
  ] as any });

const executeFilter = function() {

  let hasFilter = false;
  const f: UserSearchInput = {
    page: page,
    perPage: itemsPerPage.value,
    scope: FilterScopeEnum.WithTrashed,
    q: '',
    sort: {} as SortUserInput
  };

  if (!filter.data.q && !filter.data.sort) {
    return;
  }

  if (filter.data.q) {
    hasFilter = true;
    f.q = filter.data.q;
  }

  if (filter.data.sort) {
    hasFilter = true;
    f.sort = filter.data.sort;
  }else{
    f.sort = {  name: SortOrderEnum.Asc };
  }
  if(filter.data.and?.account){
    hasFilter = true;
    f.and = {
      account: filter.data.and?.account
    }
  }

  if (hasFilter) {
    loadUsers(f);
  } else {
    Swal.fire({
      title: i18n.t("form.noFilterTitle"),
      text: i18n.t("form.noFilterText")
    })
  }
}


const cleanFilter = function() {
  filter.data = {
    q: ''
  } as UserSearchInput

  loadUsers(filterParamsDefault)
}

const onPageChanged = function(newPage: number) {
  page = newPage;
  loadUsers(filterParamsDefault);
}

onMounted(() => {
  loadUsers(filterParamsDefault);


  store.subscribeAction({
    after: (action) => {
      if (action.type === VUEX_ACTIONS.setUserInfo) {
        checkHasWritePermission();
      }
    }
  });

  checkHasWritePermission();

  if(hasPermission(PermissionEnum.AccountRead)){
    loadAccounts();
  }
});

const doNew = function() {
  router.push({ name: ROUTE_NAMES.newUser });
};

// function doEdit() {
//   router.push({ name: ROUTE_NAMES.editUser });
// };

const edit = function(id: string) {
  router.push({ name: ROUTE_NAMES.editUser, params: { id: id }});
}

const doRemove = async function(id: string) {
  const service = new UserService();
  const result = await service.remove(id);
  if (result && result.data.id) {
    executeFilter()
  }
}
const doRestore = async function(id: string) {
  const service = new UserService();
  const result = await service.restore(id);
  if (result && result.data.id) {
    executeFilter()
  }
}

function remove(user: User) {
  Confirm.fire({
    title: "Desativar usuário/a",
    text: `Deseja realmente desativar o/a usuário/a ${user.username}`
  })
  .then((result) => {
    if (result.isConfirmed) {
      doRemove(user.id);
    }
  })
}
function restore(user: User) {
  Confirm.fire({
    title: "Reativar usuário/a",
    text: `Deseja realmente reativar o/a usuário/a ${user.name}`
  })
      .then((result) => {
        if (result.isConfirmed) {
          doRestore(user.id);
        }
      })
}
// watch(page, (value: number) => {
//   router.push({ query: { 'page': value } });
// });

// const route = useRoute();
// watch(route, () => {
//   if (route.name?.toString() === ROUTE_NAMES.users) {
//     const newPage = route.query && route.query.page ? parseInt(route.query.page.toString()) : 1;
//     if (newPage !== pageLoaded) {
//       page.value = newPage;
//       loadUsers();
//     }
//   }
// });


return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_VField = _resolveComponent("VField")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_va_accordion = _resolveComponent("va-accordion")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_data_table = _resolveComponent("va-data-table")!
  const _component_base_list = _resolveComponent("base-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_list, {
      page: _unref(page),
      "page-count": pageCount.value,
      "current-route": _unref(ROUTE_NAMES).users,
      "page-loaded": _unref(pageLoaded),
      "show-delete": false,
      "has-filter": true,
      onPageChanged: onPageChanged,
      onDoNew: doNew
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_va_accordion, { style: {"max-width":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_component_va_collapse, {
                header: _ctx.$t('list.filters')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_card_content, { style: {"background-color":"var(--va-collapse-header-content-background-color)"} }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_VField, { name: "q" }, {
                                default: _withCtx(({ field}) => [
                                  _createVNode(_component_va_input, _mergeProps(field, {
                                    modelValue: _unref(filter).data.q,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(filter).data.q = $event)),
                                    class: "mb-4",
                                    outline: "",
                                    label: "Buscar",
                                    type: "search"
                                  }), null, 16, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            (_unref(accounts).data.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  _createElementVNode("div", _hoisted_5, [
                                    _hoisted_6,
                                    _withDirectives(_createElementVNode("select", {
                                      id: "account",
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(filter).data.and.account = $event)),
                                      name: "account"
                                    }, [
                                      _hoisted_7,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accounts).data, (op) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: op.id,
                                          value: op.id
                                        }, _toDisplayString(op.name), 9, _hoisted_8))
                                      }), 128))
                                    ], 512), [
                                      [_vModelSelect, _unref(filter).data.and.account]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('list.sort')), 1),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(filter).data.sort = $event)),
                                  name: "sort"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(optionsSort).data, (op) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: op.value,
                                      value: op.value
                                    }, _toDisplayString(op.text), 9, _hoisted_12))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _unref(filter).data.sort]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_va_button, {
                                color: "info",
                                onClick: executeFilter
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('list.executeFilter')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_va_button, {
                                class: "ml-3",
                                color: "warning",
                                onClick: cleanFilter
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('list.cleanFilter')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_va_data_table, {
          items: _unref(users).data,
          columns: _unref(headers).data,
          "sticky-header": "",
          loading: loadingUsers.value,
          "no-data-html": "Sem resultados",
          style: _normalizeStyle({
          '--va-data-table-scroll-table-color': 'var(--va-divider)'
        })
        }, {
          "cell(name)": _withCtx(({ rowData }) => [
            _createElementVNode("div", {
              class: "pointer",
              onClick: ($event: any) => (edit(rowData.id))
            }, [
              _createTextVNode(_toDisplayString(rowData.name) + " ", 1),
              (rowData.deletedAt)
                ? (_openBlock(), _createBlock(_component_va_chip, {
                    key: 0,
                    outline: "",
                    color: "warning",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_14)
          ]),
          "cell(roles)": _withCtx(({ rowData }) => [
            _createElementVNode("span", null, _toDisplayString(getLabelRoles(rowData.roles)), 1)
          ]),
          "cell(actions)": _withCtx(({ rowData }) => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_va_button, {
                icon: "fas fa-edit",
                round: "",
                size: "small",
                preset: "plain",
                color: "info",
                class: "mr-1",
                onClick: ($event: any) => (edit(rowData.id))
              }, null, 8, ["onClick"]),
              (!rowData.deletedAt)
                ? (_openBlock(), _createBlock(_component_va_button, {
                    key: 0,
                    icon: "fas fa-trash",
                    class: "danger",
                    size: "small",
                    onClick: ($event: any) => (remove(rowData))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (rowData.deletedAt)
                ? (_openBlock(), _createBlock(_component_va_button, {
                    key: 1,
                    icon: "fas fa-repeat",
                    color: "warning",
                    class: "warning",
                    size: "small",
                    onClick: ($event: any) => (restore(rowData))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["items", "columns", "loading", "style"])
      ]),
      _: 1
    }, 8, ["page", "page-count", "current-route", "page-loaded"])
  ]))
}
}

})